import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ProjectBasicInfoSubProject from '../../../widgets/projectBasicInfo/ProjectBasicInfoSubProject'
import ProjectProgressStep from '../../../widgets/projectProgress/ProjectProgressStep'
import ProjectProgressTimeline from '../../../widgets/projectProgress/ProjectProgressTimeline'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import {
  getProjectOverviewSubProject,
  getSubProjectPDPA,
  saveSubProjectPDPA,
} from '../../../redux/actions/projectOverview'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProjectCost from '../projectCost/ProjectCost'
import BudgetInstallmentPlanDetail from '../../../widgets/budgetInstallmentPlanDetail/BudgetInstallmentPlanDetail'
import { Checkbox, Message, Modal, Panel, Button } from 'rsuite'
import notification from '../../../utils/notification'
import pathname from '../../../constants/pathname'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { useHistory } from 'react-router-dom'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import PDPANoticeModal from '../../../components/pdpa/PDPANoticeModal'

export default function overviewCoworker() {
  const [isEditAll, setIsEditAll] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()

  const [acceptPDPA, setAcceptPDPA] = useState()
  const [showPDPA, setShowPDPA] = useState(true)
  const [PDPASchema, setPDPASchema] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem(SUB_PROJECT_ID)
  const history = useHistory()

  useEffect(() => {
    handleGetSchema()
    projectId && handleGetPDPA()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectOverviewSubProject(projectId)
      // console.log('schema => ', JSON.stringify(_schema))
      setSchema(_schema)
      //setSchema(mockData)
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetPDPA = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSubProjectPDPA(projectId)
      setPDPASchema(response)
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: `PDPA error : ${e?.response?.data?.errors?.message}`,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSavePDPA = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await saveSubProjectPDPA(projectId)
      if (response) {
        setShowPDPA(false)
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: `PDPA error : ${e?.response?.data.errors?.message}`,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onCancle = () => {
    history.push({
      pathname: `${pathname.subProject.subProjectDashboard}`,
    })
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isNewSubProject>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {schema?.forms?.projectInfo && (
          <ProjectBasicInfoSubProject schema={schema.forms.projectInfo} />
        )}

        {schema?.forms?.projectCostDashboard && (
          <ProjectCost schema={schema.forms.projectCostDashboard} />
        )}
        <br />

        {schema?.forms?.budgetInstallment && (
          <BudgetInstallmentPlanDetail schema={schema.forms.budgetInstallment} />
        )}
        {/* <br /> */}

        {/* <div>
          <Panel shaded bordered bodyFill>
            <Message
              type={schema.forms.message.type}
              description={<div dangerouslySetInnerHTML={{ __html: schema.forms.message.desc }} />}
            />
          </Panel>
        </div> */}

        <br />
        {/* {schema?.forms?.progressStep && (
          <>
            <ProjectProgressStep schema={schema.forms.progressStep} />
            <br />
          </>
        )} */}

        {schema?.forms?.progressTimeLine && (
          <ProjectProgressTimeline schema={schema.forms.progressTimeLine} />
        )}
        <br />
      </SidebarProposal>

      {PDPASchema?.forms?.pdpa &&
        (PDPASchema?.forms?.pdpa.isDep6 ? (
          <PDPANoticeModal
            show={showPDPA}
            onHide={onCancle}
            shouldRenderPdpaContent={!isLoading}
            acceptPDPA={acceptPDPA}
            setAcceptPDPA={setAcceptPDPA}
            saveButton={
              <SaveButton
                icon="check"
                disabled={!acceptPDPA}
                children="ยืนยัน"
                onClick={() => {
                  handleSavePDPA()
                }}
              />
            }
            cancelButton={<CancelButton children="ยกเลิก" onClick={onCancle} />}
          />
        ) : (
          <Modal backdrop size={'sm'} show={showPDPA} onHide={onCancle}>
            <Modal.Header>
              <Modal.Title>
                <p style={{ paddingTop: '0.5rem' }}>PDPA</p>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div style={{ marginLeft: 5, marginRight: 5 }}>
                {PDPASchema?.forms?.pdpa?.message}
                <Button
                  block
                  color="blue"
                  style={{ minWidth: 200, marginTop: 20 }}
                  appearance="primary"
                  disabled={isLoading}
                  onClick={() => {
                    if (PDPASchema?.forms?.pdpa.url) {
                      window.open(PDPASchema?.forms?.pdpa.url, '_blank')
                    } else {
                      notification.open('error', {
                        title: 'ไม่พบ URL อ่านรายละเอียด PDPA',
                        duration: 5000,
                      })
                    }
                  }}
                >
                  {PDPASchema?.forms?.pdpa?.readPdpa}
                </Button>
                <Checkbox
                  style={{ marginTop: 20 }}
                  checked={acceptPDPA}
                  onChange={(_, check) => {
                    console.log('c : ', check)

                    setAcceptPDPA(check)
                  }}
                >
                  {PDPASchema?.forms?.pdpa?.checkbox}
                </Checkbox>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <SaveButton
                disabled={!acceptPDPA}
                children="บันทึก"
                onClick={() => {
                  handleSavePDPA()
                }}
              />
              <CancelButton children="ยกเลิก" onClick={onCancle} />
            </Modal.Footer>
          </Modal>
        ))}
    </>
  )
}
